import TableCell, { TableCellProps } from '@mui/material/TableCell';
import { Amount, amountFormatter, AppTableCellType, dateFormatter, numberFormatter, percentageFormatter } from 'azshared';
import React from 'react';
import './table.scss';

export interface AppTableCellProps extends TableCellProps {
	type: AppTableCellType;
	showNd?: boolean;
}

const formatChild = (type: AppTableCellType, value: any,showNd=false) => {
	if (value == null && showNd) return 'N/D';
  if (value == null && !showNd) return '';
  if (value?.value === -1) return 'N/D';
	switch (type) {
		case 'amount':
			return amountFormatter(value as Amount, { currencyDisplay: 'code',showNd });
		case 'date':
			return dateFormatter(value as Date) || '-';
		case 'percentage':
			return percentageFormatter(value as number) || 'N/D';
		case 'number':
			return numberFormatter(value as number);
		default:
			return value;
	}
};

export const AppTableCell = (props: AppTableCellProps) => (
	<TableCell {...props} className={`app-table-cell app-table-cell-${props.type} ${props.className || ''}`}>
		{formatChild(props.type as any, props.children as any,props.showNd)}
	</TableCell>
);
